export const GivelifyLegacyColorPalette = {
    primary: '#715AFF',
    primaryAlt: '#F85520',
    primaryDarkGray: '#282636',
    primaryWhite: '#FFFFFF',
    accentDarkBlue: '#5F48F0',
    accentPrimaryAlt: '#E34612',
    accentPrimaryDarkAlt: '#D93B07',
    accentGivingGreen: '#C6BDFF',
    accentAvatarBlue: '#f4f2ff',
    accentBlue25: '#ECF4F7',
    neutralGrey: '#73717F',
    neutralGrey75: '#94939E',
    neutralPlatinum: '#E4E3E8',
    neutralHoverGrey: '#EEEDF3',
    neutralBlue30: '#D2E8F4',
    neutralDark: '#1A051D',
    graphBlue1: '#715AFF',
    graphBlue2: '#9C8CFF',
    graphBlue3: '#C6BDFF',
    graphGreen1: '#49DCB1',
    graphGreen2: '#B6F1E0',
    error: '#EB3333',
    error75: '#EF5353',
    error25: '#FDEEEE',
    warning: '#CC7E00',
    warning75: '#FFDA85',
    warning25: '#FEFAEC',
    success: '#00AC31',
    success75: '#73c997',
    success25: '#EBF9EF',
    backgroundTooltip: "'#717171'",

    generosityOrange: '#F85520',
    generosityOrange600: '#C83808',
    generosityOrangeButtonHover: '#E34612',
    generosityOrangeButtonPressed: '#D93B07',
    generosityOrangeLightNavHover: '#FEF1ED',
    black: '#282636',
    white: '#FFFFFF',
    guidingViolet: '#715AFF',
    guidingVioletButtonHover: '#5F48F0',
    guidingVioletButtonPressed: '#5039E3',
    guidingVioletLight: '#F4F2FF',
    accentViolet100: '#C6BDFF',
    grey50: '#FAFAFC',
    grey100: '#F3F3F7',
    grey200: '#D0CFD9',
    grey300: '#BAB8C7',
    grey500: '#94939E',
    grey600: '#73717F',
    disabled: '#E4E3E8',
    chartViolet400: '#715AFF',
    chartViolet300: '#A293FF',
    chartViolet200: '#C6BDFF',
    chartMint400: '#49DCB1',
    chartMint200: '#80E6C8',
    chartGreen100: '#B6F1E0',
    chartBlue100: '#1799F7',
    chartBlue200: '#8BCCFB',
    error300: '#EB3333',
    error200: '#EF5353',
    error100: '#FDEEEE',
    warning300: '#CC7E00',
    warning200: '#FFDA85',
    warning100: '#FEFAEC',
    success300: '#00AC31',
    success200: '#73c997',
    success100: '#EBF9EF',
    info100: '#E9F9FF',
    info200: '#6AC5E7',
    navigationTextDefault: '#6A6873',
    navigationTextHover: '#6A6873',
};

export type GivelifyLegacyColor = keyof typeof GivelifyLegacyColorPalette;
export type GivelifyLegacyColorOrString =
    | GivelifyLegacyColor
    | (string & { fromT?: unknown });

export type BoxPalette = {
    background: string;
    text: string;
    border: string;
};

export type ButtonPalette = {
    idle: BoxPalette;
    hover: BoxPalette;
    active: BoxPalette;
    disabled: BoxPalette;
};

export type GasLegacyPaletteType = {
    primary: {
        main: string;
        dark: string;
        light: string;
        contrastText: string;
    };
    background: {
        default: string;
        paper: string;
    };
    action: {
        disabled: string;
        disabledBackground: string;
        disabledOpacity: number;
        hover: string;
    };
    error: {
        main: string;
        dark: string;
        light: string;
    };
    success: {
        main: string;
        dark: string;
        light: string;
    };
    warning: {
        main: string;
        dark: string;
        light: string;
    };
    info: {
        main: string;
        dark: string;
        light: string;
    };
    text: {
        primary: string;
        secondary: string;
        disabled: string;
    };
    label: {
        primary: string;
        secondary: string;
        light: string;
        contrast: string;
        placeholder: string;
    };
    graph: {
        colors: string[];
        envelopeDonutColors: {
            occasional: string;
            new: string;
            consistent: string;
            decreasing: string;
            inactive: string;
        };
    };
};
export const GasLegacyPalette: GasLegacyPaletteType = {
    primary: {
        main: GivelifyLegacyColorPalette.primary,
        dark: GivelifyLegacyColorPalette.accentDarkBlue,
        light: GivelifyLegacyColorPalette.accentAvatarBlue,
        contrastText: GivelifyLegacyColorPalette.primaryWhite,
    },
    background: {
        default: GivelifyLegacyColorPalette.primaryWhite,
        paper: GivelifyLegacyColorPalette.primaryWhite,
    },
    action: {
        disabled: GivelifyLegacyColorPalette.neutralGrey75,
        disabledBackground: GivelifyLegacyColorPalette.neutralPlatinum,
        disabledOpacity: 1,
        hover: GivelifyLegacyColorPalette.neutralHoverGrey,
    },
    error: {
        main: GivelifyLegacyColorPalette.error75,
        dark: GivelifyLegacyColorPalette.error,
        light: GivelifyLegacyColorPalette.error25,
    },
    success: {
        main: GivelifyLegacyColorPalette.success75,
        dark: GivelifyLegacyColorPalette.success,
        light: GivelifyLegacyColorPalette.success25,
    },
    warning: {
        main: GivelifyLegacyColorPalette.warning75,
        dark: GivelifyLegacyColorPalette.warning,
        light: GivelifyLegacyColorPalette.warning25,
    },
    info: {
        main: GivelifyLegacyColorPalette.graphBlue2,
        dark: GivelifyLegacyColorPalette.graphBlue1,
        light: GivelifyLegacyColorPalette.graphBlue3,
    },
    text: {
        primary: GivelifyLegacyColorPalette.primaryDarkGray,
        secondary: GivelifyLegacyColorPalette.neutralGrey,
        disabled: GivelifyLegacyColorPalette.neutralPlatinum,
    },
    label: {
        primary: GivelifyLegacyColorPalette.black,
        secondary: GivelifyLegacyColorPalette.grey600,
        light: GivelifyLegacyColorPalette.grey500,
        contrast: GivelifyLegacyColorPalette.white,
        placeholder: GivelifyLegacyColorPalette.grey600,
    },
    graph: {
        colors: [
            GivelifyLegacyColorPalette.guidingViolet,
            GivelifyLegacyColorPalette.chartViolet300,
            GivelifyLegacyColorPalette.chartViolet200,
            GivelifyLegacyColorPalette.chartGreen100,
            GivelifyLegacyColorPalette.chartMint200,
            GivelifyLegacyColorPalette.chartMint400,
            GivelifyLegacyColorPalette.chartBlue100,
            GivelifyLegacyColorPalette.chartBlue200,
            GivelifyLegacyColorPalette.grey100,
            GivelifyLegacyColorPalette.grey200,
            GivelifyLegacyColorPalette.grey300,
        ],
        envelopeDonutColors: {
            occasional: GivelifyLegacyColorPalette.chartViolet200,
            new: GivelifyLegacyColorPalette.chartViolet300,
            consistent: GivelifyLegacyColorPalette.chartViolet400,
            decreasing: GivelifyLegacyColorPalette.chartMint200,
            inactive: GivelifyLegacyColorPalette.chartMint400,
        },
    },
};
